import { Week } from "@kanpla/types";

export const subtractWeek = (week: Week) =>
  week.map((day) => {
    const newDay = day;
    newDay.seconds -= 604800;
    return newDay;
  }) as Week;
